import Button from "@mui/material/Button";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiClient, ADMIN_SERVER_BASE_URL } from "../util/apiClient";
import {
  addModeleRapport,
  IModeleRapport,
  IPlanItem,
  // setHideListeModele,
} from "../store/modeleRapportSlice";
import { IReduxState } from "../store";
import { Box, Grid, MenuItem, TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { errorNotify, successNotify } from "../util/functions";
import { AnyAsyncThunk } from "@reduxjs/toolkit/dist/matchers";
import Autocomplete from "@mui/material/Autocomplete";


export interface IAddModeleAPartirDUnModeleExistantProps {
  planRapport: IPlanItem[];
  setPlanRapport: any;
  currentModele: any;
  setCurrentModele: any;
  planItem: IPlanItem | undefined;
  setPlanItem: any;
  mode: string;
  setMode: any;
  typeRapport: any;
}

export default function AddModeleAPartirDUnModeleExistant(
  props: IAddModeleAPartirDUnModeleExistantProps
) {
  //props
  const {
    planRapport,
    setPlanRapport,
    planItem,
    setPlanItem,
    // setCurrentModele,
    // currentModele,
    typeRapport,
    mode,
    setMode,
  } = props;

  //redux
  const dispatch = useDispatch();
  const { modelesRapport } = useSelector(
    (state: IReduxState) => state.modeleRapport
  );

  //hooks
  const [libelleModeleRapport, setLibelleModeleRapport] = useState<string>("");
  const [currentModele, setCurrentModele] = useState<any>({});
  const [loading, setLoading] = useState(false);


  const handleSave = async () => {
    try {
      setLoading(true)
      const apiPayload = {
        libelleModeleRapport: libelleModeleRapport,
        // idModeleRapport:idModele,
        planModeleRapport: planRapport,
        idTypeRapport: typeRapport.idTypeRapport
      };
      console.log("🚀 ~ handleSave ~ apiPayload:", apiPayload)


      // return
      const res: any = await apiClient.post(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/ajoutermodelerapportapartirdemodeleexistant",
        apiPayload
      );
      if (res.status === 1) {
        // const parsedData = {
        //   ...res.data,
        //   planModeleRapport: JSON.parse(res.data.planModeleRapport),
        // };

        dispatch(addModeleRapport(res.data));
        setPlanRapport([]);
        setLibelleModeleRapport("");
        setCurrentModele({});
        setLoading(false)
        successNotify("Modèle de rapport creé avec succès.");
      } else {
        console.log("status !==1");
        setLoading(false)
        errorNotify("Erreur de création du modèle de rapport.");
      }
    } catch (error) {
      setLoading(false)
      console.log("🚀 ~ file: handleSave ~ error", error);
      errorNotify("Erreur de création du modèle de rapport.");
    }
  };

  //obtenir le plan du rapport selectionné
  useEffect(() => {
    const modele = modelesRapport.find(
      (item) => item.idModeleRapport === currentModele?.idModele
    );
    if (modele) {
      setPlanRapport(modele.planModeleRapport);
    }
    // dispatch(setHideListeModele(false));
  }, [currentModele?.idModele]);

  return (
    <div style={{ marginBottom: 10, backgroundColor: "#ECF0F3", padding: 20 }}>
      <Grid container spacing={2}>
        <Grid item md={12} xs={12} sm={12}>

          <Autocomplete
            fullWidth
            onChange={(e: any, modeleItem) => {
              if (modeleItem) {
                setCurrentModele({
                  ...currentModele,
                  idModele: modeleItem.idModeleRapport
                });
              }
            }}
            options={modelesRapport}
            renderOption={(props, modeleItem) => {
              const { libelleModeleRapport, idModeleRapport } = modeleItem;
              const newIndex = modelesRapport.findIndex(item => item.idModeleRapport === idModeleRapport)
              return (
                <span {...props}
                  style={{ backgroundColor: (newIndex % 2 === 0) ? "aliceblue" : "", fontSize: 13 }}
                >
                  {libelleModeleRapport}
                </span>
              );
            }}

            getOptionLabel={(modeleItem) =>
              `${modeleItem.libelleModeleRapport}`
            }

            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                fullWidth
                size="small"
                label="Choisir un modèle de rapport"
              />
            )}
          />

          {/* <TextField
            fullWidth
            size="small"
            select
            label="Choisir un modèle"
            name="idModele"
            value={idModele}
            onChange={(e) => setIdModele(e.target.value)}
          >
            {modelesRapport.map((item: IModeleRapport, index: number) => (
              <MenuItem key={index} value={item.idModeleRapport}>
                {item.libelleModeleRapport}
              </MenuItem>
            ))}
          </TextField> */}
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            name="libelleModele"
            label="libellé"
            value={libelleModeleRapport}
            onChange={(e: any) => setLibelleModeleRapport(e.target.value)}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
          >
            <LoadingButton
              loadingPosition="end"
              loading={loading}
              endIcon={<SaveIcon />}
              size="small"
              variant="contained"
              onClick={handleSave}
            >
              Enregistrer
            </LoadingButton>

            {/* <Button size="small" variant="contained" onClick={handleSave}>
              Enregistrer
            </Button> */}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
